import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-tabs";
import BaseViewModel from "./../../factories/search-paging2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabController from "./../../factories/tab-controller";
import BaoDialog from "./../../factories/bao-dialog";
class EquipmentViewModel extends BaseViewModel {
    EquipmentText: KnockoutObservable<string>;
    DetailTabPage: TabPage;
    Device3TabPage: TabPage;
    ShiftbookAreaEquipmentTabPage: TabPage;
    constructor(tabPage: TabPage) {
        super(tabPage);
        // hack only necessary until next bao update
        this["PermissionForward"] = "EquipmentForward";
        this["PermissionBackward"] = "EquipmentBackward";
        // hack end
    }
    CompleteCheck() {
        var isComplete: boolean = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.EquipmentText())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "MasterData/Equipment/Init";
    }
    init() {
        return super.init().then(() => {
            //load tabs
            return super.InitTabController().then(() => {
                this.DetailTabPage = new TabPage();
                this.DetailTabPage.IsClosable(false);
                this.DetailTabPage.Url("MasterData/EquipmentAreaDetailTab");
                this.TabController.AddTab(this.DetailTabPage);
                this.Device3TabPage = new TabPage();
                this.Device3TabPage.AutoSelect = false;
                this.Device3TabPage.IsClosable(false);
                this.Device3TabPage.Url("MasterData/EquipmentDevice3AssignmentTab");
                this.TabController.AddTab(this.Device3TabPage);
                this.ShiftbookAreaEquipmentTabPage = new TabPage();
                this.ShiftbookAreaEquipmentTabPage.IsClosable(false);
                this.ShiftbookAreaEquipmentTabPage.Url("MasterData/ShiftbookAreaEquipmentTab");
                this.ShiftbookAreaEquipmentTabPage.AutoSelect = false;
                this.TabController.AddTab(this.ShiftbookAreaEquipmentTabPage);
            });
        });
    }
}
export default EquipmentViewModel;